import { GetCompanyDataWithCompanyNameAndYear, GetCompanyForCompanySelection, GetFinancialYearByCompanyName, UserAuthentication } from "../ApiEndPoints.js";
import { axiosGetWithencryption, axiosPost, axiosPostWithencryption } from "../AxiosRequests.js";

export default class AdminLoginServices {

    async getCompanyForCompanySelection(request) {
        return axiosGetWithencryption(GetCompanyForCompanySelection, request);
    }

    async getFinancialYearByCompanyName(request) {
        return axiosGetWithencryption(GetFinancialYearByCompanyName, request);
    }

    async getCompanyDataWithCompanyNameAndYear(request) {
        return axiosPostWithencryption(GetCompanyDataWithCompanyNameAndYear, request);
    }

    async userAuthentication(request) {
        return axiosPost(UserAuthentication, request)
    }
}

